import PropTypes from "prop-types"
import { FACTOR, SECURITY, AGGREGATION, BASE } from "../../shapes"
import Position from "../position"
import Aggregation from "../aggregation"
import Base from "../base"
import { numberCommasFormatter } from "helpers/formatters/numbers"
import "./style.scss"

function getColorClass(value, contentSetId) {
  if (contentSetId) {
    return ""
  }

  switch (true) {
    case value < -2:
      return "cold-darker"
    case value < -1.5:
      return "cold-dark"
    case value < -1:
      return "cold-base"
    case value < -0.5:
      return "cold-light"
    case value < -0.2:
      return "cold-lighter"
    case value > 2:
      return "hot-darker"
    case value > 1.5:
      return "hot-dark"
    case value > 1:
      return "hot-base"
    case value > 0.5:
      return "hot-light"
    case value > 0.2:
      return "hot-lighter"
    default:
      return ""
  }
}

function Row({ row, factors, toggleAggregation, openSecurityProfile, openFactorProfile, contentSetId }) {
  const { type } = row

  const cells = factors.map(factor => {
    const value = factor.getValue(row, factor.id)
    const classNames = [type, factor.type]
    const title = factor.id === "size" ? numberCommasFormatter(value) : null

    if (factor.type === "factor") {
      if (row.aggregationType === "net" || row.key === "Active") {
        classNames.push(getColorClass(value * 2, contentSetId))
      } else {
        classNames.push(getColorClass(value, contentSetId))
      }
    }

    return <td key={factor.id} title={title} className={classNames.join(" ")}>
      {factor.formatter(value, type)}
    </td>
  })

  switch (type) {
    case "aggregation":
      return <Aggregation {...{ row, toggleAggregation }}>{cells}</Aggregation>
    case "base":
      return <Base {...{ row }}>{cells}</Base>
    default:
      return <Position {...{ row, openSecurityProfile, openFactorProfile }}>{cells}</Position>
  }
}

Row.propTypes = {
  factors: PropTypes.arrayOf(FACTOR).isRequired,
  row: PropTypes.oneOfType([SECURITY, AGGREGATION, BASE]).isRequired,
  toggleAggregation: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  contentSetId: PropTypes.string,
}

export default Row
